import * as React from 'react'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, lowerCase, capitalize, map, orderBy } from 'lodash/fp'
import LinedTable from 'components/Tables/LinedTable'
import { ICall } from 'features/CallAnalytics/types'
import * as sMarg from 'styles/modules/margins.scss'

const fixCaps = flow(lowerCase, capitalize)

const formatData = (calls: ICall[]) =>
  flow(
    groupBy<ICall[]>('location'),
    map((items: ICall[]) => ({
      name: fixCaps(items[0].location),
      value: items.length,
    })) as any,
    orderBy(['value'], ['desc'])
  )(calls) as { name: string; value: number }[]

export interface ICallsByLocationTableProps {
  loading: boolean
  calls: ICall[]
}

export class CallsByLocationTable extends React.Component<ICallsByLocationTableProps> {
  state = {
    count: 14,
  }
  showMore = () =>
    this.setState({
      count: this.state.count + 14,
    })
  render() {
    const { calls, loading } = this.props
    const { count } = this.state
    const data = formatData(calls)
    const dataLimited = data.slice(0, count)
    const moreResults = data.length > dataLimited.length

    return (
      <InfoCard
        style={{ height: '100%' }}
        title="Calls by location"
        loading={loading}
        allowOverflow
      >
        <LinedTable>
          {dataLimited.map(item => (
            <div key={item.name}>
              <div>{item.name}</div>
              <div>{item.value}</div>
            </div>
          ))}
        </LinedTable>
        {moreResults && (
          <a onClick={this.showMore} className={sMarg.mt30}>
            Show more
          </a>
        )}
      </InfoCard>
    )
  }
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsByLocationTable/CallsByLocationTable.tsx